<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle *ngIf="!generatingLetter">
  <h5 class="modal-title">Ad Hoc Letter</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body" *ngIf="!generatingLetter">
  <div class="mb-3 row">
    <label class="col-sm-3 col-form-label">Letter Recipient</label>
    <div class="col-sm-9">
      <select class="form-select" 
              [(ngModel)]="recipientType" 
              *ngIf="recipients.length > 0">
        <option *ngFor="let recipient of recipients" [ngValue]="recipient.recipientId">
          {{recipient.recipientType}}
        </option>
      </select>
    </div>
  </div>
</div>

<div class="modal-body text-center" *ngIf="generatingLetter && !generatingError">
  <h5>Generating Letter - Please do not leave the page</h5>
  <div class="my-4">
    <div class="spinner-border text-success" style="width: 3rem; height: 3rem;" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</div>

<div class="modal-body text-center" *ngIf="generatingError">
  <h5 class="text-danger">An Error Occurred</h5>
  <div class="alert alert-danger mt-3">
    {{errorMessage}}
  </div>
</div>

<div class="modal-footer" *ngIf="!generatingLetter">
  <button type="button" 
          class="btn btn-success" 
          (click)="generateLetter()" 
          [disabled]="!recipientType">
    Generate Letter
  </button>
</div>